import { render, staticRenderFns } from "./upload-lab-results-modal.vue?vue&type=template&id=fee8e8e2"
import script from "./upload-lab-results-modal.vue?vue&type=script&lang=js"
export * from "./upload-lab-results-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports